import React, { useEffect, useState } from 'react';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import Input from '../Common/Input';
import InputMask from '../Common/InputMask';
import Select from '../Common/Select';
import CustomInput from '../Common/CustomInput';
import ReactSelect from '../Common/ReactSelect';

const Form = ({ formik, isEditMode }) => {

    const [holdings, setHoldings] = useState([]);
    const [branches, setBranches] = useState([]);
    const { readData: getHoldings } = useEntityCrud('Branch/GetAllHoldings');
    const { readData: getBranches } = useEntityCrud('Branch/GetAllBranchs');

    useEffect(() => {
        getHoldings().then(({ data }) => {
            if(data.status)
                setHoldings(data.result);
        });
        getBranches().then(({ data }) => {
            if(data.status)
                setBranches([...data.result.map(branch => ({label: branch.title,value: branch.id}))]);
        });
    }, []);

    const toBase64 = async file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    const handleFileInput = async (e, name) => {
        const file = e.target.files[0];
        const finalFile = await toBase64(file);
        formik.setFieldValue(name, finalFile);
    }

    const openImage = image => {
        let a = window.document.createElement('a');
        a.setAttribute('href', image);
        let fileName = Date.now()
        a.setAttribute('download', fileName);
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <div className="col-md-3">
                    <Input label="عنوان" name="title" required={true} formik={formik} />
                </div>
                <div className="col-md-6">
                    <Input label="آدرس" name="address" required={true} formik={formik} />
                </div>
                <div className="col-md-3">
                    <InputMask label="شماره تماس" name="phone" required={true} formik={formik} isLtr={true} mask="999-99999999" />
                </div>
                <div className="col-md-3">
                    <Select label="هلدینگ" name="holdingId" formik={formik} required={true}>
                        {holdings.map(holding => (
                            <option value={holding.id} key={holding.id}>{holding.title}</option>
                        ))}
                    </Select>
                </div>
                <div className="col-md-3">
                    <ReactSelect label="والد" name="parentId" formik={formik} options={branches} value={branches.find(branch => branch.value == formik.values.parentId)} />
                </div>
                <div className="col-md-3 ">
                    <CustomInput
                        style={{ marginBottom: "0px !important" }}
                        label="لوگو"
                        accept="image/jpeg,image/png"
                        name="logo"
                        formik={formik}
                        onchange={e => handleFileInput(e, 'logo')}
                        type="file"
                        isLtr={true} />


                    {!isEditMode && formik.values.logo && !formik.values.logo?.includes('null') && !formik.values.logo?.includes('undefined') &&
                        <img src={formik.values.logo} className='boxShadowImg' />
                    }

                    {isEditMode && (formik.values.logo !== `data:image/jpeg;base64,null`) && formik.values.logo?.includes('null') && formik.values.logo?.includes('undefined') &&
                        (formik.values.logo !== `data:image/jpeg;base64,undefined`) &&
                        <img src={formik.values.logo} className='boxShadowImg' />
                    }

                </div>
            </div>
            <button className="btn btn-success" id="btn-submit-form">ذخیره اطلاعات</button>
        </form>
    );
}

export default Form;